import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../ui/button';

export const Timeout = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center gap-20 [@media(min-width:1800px)]:gap-40 w-[90%] max-w-[60rem] h-screen bg-white pt-[5.3125rem] pb-20 mx-auto">
      <div className="flex items-center justify-center bg-[#DEE3FC] size-[6.375rem] rounded-full">
        <img src="/images/user-logout.svg" alt="User Logout" className="size-11" />
      </div>
      <div className="max-w-[31.875rem] flex flex-col items-center justify-center gap-12">
        <p className="text-center text-[#21272A] text-xl font-normal leading-normal">
          For your security, you’ve been logged out due to a period of inactivity. You can log back in anytime to continue where you left.
        </p>
        <Button
          type="button"
          variant="primary"
          className="w-fit"
          onClick={() => navigate('/login')}
        >
          Log back in
        </Button>
      </div>
    </div>
  );
};
